import { render } from "./JournalTabImar.vue?vue&type=template&id=353388cd&scoped=true"
import script from "./JournalTabImar.vue?vue&type=script&lang=js"
export * from "./JournalTabImar.vue?vue&type=script&lang=js"

import "./JournalTabImar.vue?vue&type=style&index=0&id=353388cd&lang=scss&scoped=true"

import exportComponent from "D:\\NET\\AsdCare\\asdcare-internal\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-353388cd"]])

export default __exports__